import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleDriveFoldersComponent } from '../google-drive-folders/google-drive-folders.component';
import { Toast } from 'app/shared/toast/toast';

@Component({
  selector: 'app-google-drive-move-dialog',
  templateUrl: './google-drive-move-dialog.component.html',
  styleUrls: ['./google-drive-move-dialog.component.css']
})
export class GoogleDriveMoveDialogComponent implements OnInit, AfterViewInit {
   @ViewChild("folders", { static: true }) GoogleDriveFoldersComponentRef: GoogleDriveFoldersComponent;

   protected rootFolderId: string;
   protected access_token: string;
   protected sourceItemName: string;
   private destinationFolderId: string;
   protected destinationFolderName: string;
   public drivePath: string;
   protected isDestinationSelected = false;
   protected isRootBeingSelected = false;
   public busy: boolean;

   constructor(
      public dialogRef: MatDialogRef<GoogleDriveMoveDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: IdexService,
      private translate: TranslateService,
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private toast: Toast
   ) {
      if (this.data) {
         this.access_token = this.data.access_token;
         this.service.googleDriveGetItemFromId(this.access_token, "root").subscribe(
            (rootItem) => {
               rootItem = JSON.parse(rootItem);
               this.rootFolderId = rootItem.id;

            },
            (error) => {
               console.error(error);
               if (error.status === 401) {
                  this.dialogRef.close();
                  this.router.navigate(['/login']);
               }
            }
         );
      }
   }

   ngOnInit() {
      this.activatedRoute.queryParams.subscribe(params => {
         if (params['fileId']) {
           this.drivePath = JSON.parse(params['fileId']);
         } else {
           this.drivePath = 'root';
         }
      });
      this.sourceItemName = this.data?.itemToMove?.name;
   }

   ngAfterViewInit() {
      this.GoogleDriveFoldersComponentRef.toggle();
   }

   onSelectRoot() {
      this.isDestinationSelected = true;
      this.translate.get("google.rootFolder").subscribe((rootFolderName) => {
         this.destinationFolderName = rootFolderName;
      });
      this.destinationFolderId = 'root';

      this.GoogleDriveFoldersComponentRef.unselect();
      this.isRootBeingSelected = true;
   }

   onSelectDestinationFolder(destinationFolder: any) {
      if (!destinationFolder) return;
      if (this.isSameFolder(destinationFolder.id)) return;
      this.isDestinationSelected = true;
      this.destinationFolderName = destinationFolder.name;
      this.destinationFolderId = destinationFolder.id;

      this.isRootBeingSelected = false;
   }

   onClickConfirmMove() {
      this.busy = true;
      const currentFile = this.data?.itemToMove;
      const previousFolder = this.drivePath;
      const destinationFolder = this.destinationFolderId;
      this.service.moveFileToGoogleDrive(currentFile.id, destinationFolder, previousFolder, this.access_token).subscribe(res => {
         if(res.code == 400){
            this.translate.get("google.error_move_folder").subscribe((s) => {
               this.toast.error(s);
            });
         }else if(res.code == 200){
            this.dialogRef.close(res.message);
            this.busy = false;
            this.translate.get("alert.move_to").subscribe((s) => {
               this.toast.success(this.data?.itemToMove.name + s + this.destinationFolderName);
            });
         }else{
            this.translate.get("google.error_move_file", {from:this.data?.itemToMove.name, to:this.destinationFolderName}).subscribe((s) => {
               this.toast.error(s);
            });
         }

      });
   }

   isSameFolder(destinationFolder: any): boolean {
      if(this.activatedRoute.snapshot.queryParams['fileId'] != null){
         return destinationFolder == this.drivePath;
      }else{
         if(this.data?.itemToMove?.id == destinationFolder) return true;
         return false;
      }
   }
}
